import api from '@/services/api';

const ENTITY_ENDPOINT = 'recurso';

const recurso_service = {
  /**
   * Obtiene todos los recursos con parámetros de paginación y filtros
   * @param {string} params - Parámetros de consulta como string
   * @returns {Promise} Respuesta de la API
   */
  async findAll(params = '') {
    try {
      const response = await api.get(`/${ENTITY_ENDPOINT}?${params}`);
      return response;
    } catch (error) {
      console.error('Error finding all recursos:', error);
      throw error;
    }
  },

  /**
   * Obtiene recursos filtrados por proceso
   * @param {Object} filters - Filtros a aplicar
   * @returns {Promise} Respuesta de la API
   */
  async findByProceso(filters = {}) {
    try {
      const response = await api.get(`/${ENTITY_ENDPOINT}`, {
        params: { page: 1, ...filters },
      });
      return response;
    } catch (error) {
      console.error('Error finding recursos by proceso:', error);
      throw error;
    }
  },

  /**
   * Busca un recurso por su código
   * @param {string} codigo - Código del recurso
   * @returns {Promise} Respuesta de la API
   */
  async findByCodigo(codigo) {
    try {
      const response = await api.get(`/${ENTITY_ENDPOINT}/${codigo}`);
      return response;
    } catch (error) {
      console.error(`Error finding recurso with codigo ${codigo}:`, error);
      throw error;
    }
  },

  /**
   * Crea un nuevo recurso
   * @param {Object} data - Datos del recurso a crear
   * @returns {Promise} Respuesta de la API
   */
  async create(data) {
    try {
      const isForm = typeof FormData !== 'undefined' && data instanceof FormData;
      const response = await api.post(`/${ENTITY_ENDPOINT}`, data, {
        headers: isForm ? { 'Content-Type': 'multipart/form-data' } : undefined,
      });
      return response;
    } catch (error) {
      console.error('Error creating recurso:', error);
      throw error;
    }
  },

  /**
   * Actualiza un recurso existente
   * @param {string} codigo - Código del recurso a actualizar
   * @param {Object} data - Datos actualizados del recurso
   * @returns {Promise} Respuesta de la API
   */
  async update(codigo, data) {
    try {
      const isForm = typeof FormData !== 'undefined' && data instanceof FormData;
      const response = await api.patch(`/${ENTITY_ENDPOINT}/${codigo}`, data, {
        headers: isForm ? { 'Content-Type': 'multipart/form-data' } : undefined,
      });
      return response;
    } catch (error) {
      console.error(`Error updating recurso with codigo ${codigo}:`, error);
      throw error;
    }
  },

  /**
   * Elimina un recurso por su código
   * @param {string} codigo - Código del recurso a eliminar
   * @returns {Promise} Respuesta de la API
   */
  async delete(codigo) {
    try {
      const response = await api.delete(`/${ENTITY_ENDPOINT}/${codigo}`);
      return response;
    } catch (error) {
      console.error(`Error deleting recurso with codigo ${codigo}:`, error);
      throw error;
    }
  },
};

export default recurso_service;
